export interface AdminUserPolicy {
  canEdit: boolean;
  canImpersonate: boolean;
  canChangePassword: boolean;
  canLock: boolean;
  canDisable: boolean;
  canEditCapabilities: boolean;
  canDelete: boolean;
  eligibleForDestruction: boolean;
}

export interface AdminUser {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  phoneNumber?: string;
  avatar?: string;
  username?: string;
  portfolioUrl?: string;
  talentStatus?: string;
  talentStatusId?: string;
  talentSource?: string;
  talentSourceId?: string;
  talentManagerId?: string;
  talentTrained?: boolean;
  talentTrainedAt?: string;
  availableFreelance?: boolean;
  reportingCategory?: string;
  textOnlyEmail?: boolean;
  internalNotes?: string;
  primarySkill?: string;
  adminEnabled: boolean;
  adminManage: boolean;
  adminImpersonate: boolean;
  adminManageCapabilities: boolean;
  adminCreateTransactions: boolean;
  adminManageFeatures: boolean;
  adminManageUsers: boolean;
  adminBulkUploadUsers: boolean;
  adminManageAdminUser?: boolean;
  accessLocked: boolean;
  confirmed: boolean;
  confirmedAt?: string;
  createdAt: string;
  updatedAt?: string;
  lastSignInAt?: string;
  currentSignInAt?: string;
  signInCount?: number;
  talentScore?: number;
  expertise?: Array<{ id: string; name: string }>;
  residences?: Array<{
    id: string;
    city?: string;
    state?: string;
    country?: string;
    createdAt: string;
  }>;
  fullLocation?: string;
  policy?: AdminUserPolicy;
}

export interface AdminUpdateUserInput {
  id: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  reportingCategory?: string;
  textOnlyEmail?: boolean;
  confirmedEmail?: boolean;
  talentManagerId?: string;
  talentStatus?: string;
  talentSource?: string;
  talentTrained?: boolean;
  availableFreelance?: boolean;
  internalNotes?: string;
  expertiseIds?: string[];
  adminManage?: boolean;
  adminImpersonate?: boolean;
  adminManageCapabilities?: boolean;
  adminCreateTransactions?: boolean;
  adminEnabled?: boolean;
  adminManageFeatures?: boolean;
  adminManageUsers?: boolean;
  adminBulkUploadUsers?: boolean;
  adminManageAdminUser?: boolean;
}

// Dropdown options for the user edit form
export const REPORTING_CATEGORIES = [
  { value: '', label: 'Select one' },
  { value: 'agency', label: 'agency' },
  { value: 'client', label: 'client' },
  { value: 'internal', label: 'internal' },
  { value: 'managing_editor', label: 'managing_editor' },
  { value: 'network', label: 'network' },
];

export const TALENT_STATUSES = [
  { value: '', label: 'Select one' },
  { value: 'preapproved', label: 'preapproved' },
  { value: 'approved', label: 'approved' },
  { value: 'activated', label: 'activated' },
  { value: 'banned', label: 'banned' },
  { value: 'spam', label: 'spam' },
  { value: 'inactive', label: 'inactive' },
  { value: 'ghost', label: 'ghost' },
  { value: 'a', label: 'a' },
  { value: 'b', label: 'b' },
  { value: 'c', label: 'c' },
  { value: 'declined', label: 'declined' },
  { value: 'unresponsive', label: 'unresponsive' },
  { value: 'unassigned', label: 'unassigned' },
];

// Note: These values must match the names stored in the talent_sources database table
export const TALENT_SOURCES = [
  { value: '', label: 'Select one' },
  { value: 'Association', label: 'Association' },
  { value: 'Direct email', label: 'Direct email' },
  { value: 'Google search', label: 'Google search' },
  { value: 'Publication', label: 'Publication' },
  { value: 'Referral - Contently employee', label: 'Referral - Contently employee' },
  { value: 'Referral - Managing editor', label: 'Referral - Managing editor' },
  { value: 'Referral - Other', label: 'Referral - Other' },
  { value: 'Referral - Other freelancer', label: 'Referral - Other freelancer' },
  { value: 'Social - Behance', label: 'Social - Behance' },
  { value: 'Social - Etsy', label: 'Social - Etsy' },
  { value: 'Social - Facebook', label: 'Social - Facebook' },
  { value: 'Social - LinkedIn', label: 'Social - LinkedIn' },
  { value: 'Social - Other network', label: 'Social - Other network' },
  { value: 'Social - Pinterest', label: 'Social - Pinterest' },
  { value: 'Zendesk', label: 'Zendesk' },
];

export interface MutationError {
  path: string[];
  message: string;
  code: string;
}

export interface AdminUserMutationResult {
  success: boolean;
  user?: AdminUser;
  errors: MutationError[];
}

export interface AdminImpersonateResult {
  success: boolean;
  impersonationToken?: string;
  redirectUrl?: string;
  errors: MutationError[];
}

export interface AdminDeleteResult {
  success: boolean;
  deleted: boolean;
  message?: string;
  errors: MutationError[];
}
